const PROD_URL='https://fitpair.app';
const TOKEN_KEY='fitpair_auth_token';
const USER_KEY='fitpair_user';

async function readResponse(res) {
  const data=await res.json().catch(()=> ({}));
  if (!res.ok || data.status===false) {
    const error=new Error(data.message || 'Something went wrong. Please try again.');
    error.status=res.status;
    error.code=data.code;
    error.data=data;
    throw error;
  }
  return data;
}

function storeSession(data,fallbackUser) {
  if (data.token) {
    localStorage.setItem(TOKEN_KEY,data.token);
  }
  const user=data.user || data.data || fallbackUser;
  if (user) {
    localStorage.setItem(USER_KEY,JSON.stringify(user));
  }
}

export const authService={
  getToken: ()=> localStorage.getItem(TOKEN_KEY),
  getUser: ()=> {
    try {
      const raw=localStorage.getItem(USER_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  },
  setSession: (token,user)=> {
    if (token) {
      localStorage.setItem(TOKEN_KEY,token);
    }
    if (user) {
      localStorage.setItem(USER_KEY,JSON.stringify(user));
    }
  },
  clearSession: ()=> {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
  },
  isLoggedIn: ()=> !!localStorage.getItem(TOKEN_KEY),

  login: async (email,password)=> {
    const res=await fetch(`${PROD_URL}/auth/login`,{
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({email,password}),
    });
    const data=await res.json().catch(()=> ({}));

    if (res.status===403 && data.code===987) {
      return {
        requiresOtp: true,
        token: data.token,
        email: data.email || email,
        message: data.message,
      };
    }

    if (!res.ok || data.status===false) {
      throw new Error(data.message || 'Login failed. Please check your credentials.');
    }

    storeSession(data,{email});
    return {...data,requiresOtp: false};
  },

  register: async ({
    firstName,lastName,username,email,password,phoneNumber,dateOfBirth,
  })=> {
    const res=await fetch(`${PROD_URL}/auth/v2/register`,{
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({
        firstName,lastName,username,email,password,
        phoneNumber,date_of_birth: dateOfBirth,
      }),
    });
    const data=await readResponse(res);
    return {
      ...data,
      token: data.token,
      email,
      user: data.user || {firstName,lastName,username,email},
    };
  },

  verifyOtp: async (token,otp,fallbackUser)=> {
    const res=await fetch(`${PROD_URL}/auth/OTP/${encodeURIComponent(otp)}`,{
      method: 'GET',
      headers: {'Content-Type': 'application/json'},
    });
    const data=await readResponse(res);
    storeSession(data,fallbackUser);
    return data;
  },

  resendOtp: async (email)=> {
    const res=await fetch(`${PROD_URL}/auth/OTP`,{
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({email}),
    });
    return readResponse(res);
  },

  logout: ()=> {
    authService.clearSession();
  },
};